<script setup lang="ts">
import HugeIcon from '../HugeIcon/HugeIcon.vue';
import type { ToggleProps } from './toggle';

const props = withDefaults(defineProps<ToggleProps>(), {
  disabled: false,
  indeterminate: undefined,
});

const emits = defineEmits<(e: 'update:modelValue', value: boolean) => void>();

const handleChange = (): void => {
  emits('update:modelValue', props.indeterminate ? true : !props.modelValue);
};
</script>

<template>
  <button
    type="button"
    :role="props.indeterminate === undefined ? 'switch' : 'checkbox'"
    :aria-checked="props.indeterminate ? 'mixed' : props.modelValue"
    :disabled="props.disabled"
    class="focus:ring-primary-500 relative inline-flex h-6 w-11 min-w-11 shrink-0 items-center rounded-full transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-offset-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    :class="[
      props.modelValue && !props.indeterminate
        ? 'bg-primary-500'
        : 'bg-slate-500',
      props.indeterminate && 'justify-center',
      !props.disabled && 'cursor-pointer',
    ]"
    @click="handleChange"
  >
    <span
      class="inline-block h-4 w-4 transform rounded-full bg-white shadow-lg transition-transform duration-200 ease-in-out"
      :class="
        !props.indeterminate &&
        (props.modelValue ? 'translate-x-6' : 'translate-x-1')
      "
    >
      <HugeIcon
        v-if="props.indeterminate"
        icon="minus"
        class="text-primary-500 h-4 w-4"
        aria-hidden="true"
      />
    </span>
  </button>
</template>
